import type { UserLocaleCode } from './user-locale';
import phpLangidConfig from './php-langid-config.json';

export type PhpLangid = keyof typeof phpLangidConfig;

/**
 * Default user locale for each Carpenter language subdomain.
 * Used as fallback for first-time visitors who have no cookie yet.
 */
export const defaultUserLocaleByPhpLangid = Object.fromEntries(
   Object.entries(phpLangidConfig).map(([langid, { defaultUserLocale }]) => [
      langid,
      defaultUserLocale,
   ])
) as Record<PhpLangid, UserLocaleCode>;

/**
 * Internal language codes match PHP. Browser and Intl locales use
 * the standard "ja" code for Japanese, which maps to internal "jp".
 */
const PHP_LANGUAGE_CODE: Record<string, string> = {
   ja: 'jp',
};

export function toPhpLangId(languageCode: string): string {
   return Object.prototype.hasOwnProperty.call(PHP_LANGUAGE_CODE, languageCode)
      ? PHP_LANGUAGE_CODE[languageCode]
      : languageCode;
}

/** Convert the internal language code for external services and HTML. */
export function fromPhpLangId(phpLangId: string): string {
   return phpLangId === 'jp' ? 'ja' : phpLangId;
}
